export class WebhookV1StandardPayloadCloudAccount {
    static discriminator = undefined;
    static attributeTypeMap = [
        {
            "name": "id",
            "baseName": "id",
            "type": "string",
            "format": ""
        },
        {
            "name": "projectId",
            "baseName": "projectId",
            "type": "string",
            "format": ""
        },
        {
            "name": "timestamp",
            "baseName": "timestamp",
            "type": "Date",
            "format": "date-time"
        },
        {
            "name": "type",
            "baseName": "type",
            "type": "WebhookV1StandardPayloadCloudAccountTypeEnum",
            "format": ""
        },
        {
            "name": "arguments",
            "baseName": "arguments",
            "type": "WebhookV1StandardPayloadCloudAccountArguments",
            "format": ""
        }
    ];
    static getAttributeTypeMap() {
        return WebhookV1StandardPayloadCloudAccount.attributeTypeMap;
    }
    constructor() {
    }
}
export var WebhookV1StandardPayloadCloudAccountTypeEnum;
(function (WebhookV1StandardPayloadCloudAccountTypeEnum) {
    WebhookV1StandardPayloadCloudAccountTypeEnum["Created"] = "CLOUD_ACCOUNT_CREATED";
    WebhookV1StandardPayloadCloudAccountTypeEnum["Updated"] = "CLOUD_ACCOUNT_UPDATED";
    WebhookV1StandardPayloadCloudAccountTypeEnum["Deleted"] = "CLOUD_ACCOUNT_DELETED";
    WebhookV1StandardPayloadCloudAccountTypeEnum["Deactivated"] = "CLOUD_ACCOUNT_DEACTIVATED";
    WebhookV1StandardPayloadCloudAccountTypeEnum["Activated"] = "CLOUD_ACCOUNT_ACTIVATED";
    WebhookV1StandardPayloadCloudAccountTypeEnum["AccessLost"] = "CLOUD_ACCOUNT_ACCESS_LOST";
})(WebhookV1StandardPayloadCloudAccountTypeEnum || (WebhookV1StandardPayloadCloudAccountTypeEnum = {}));
